module.exports = __webpack_public_path__ + "static/macos-9eeaeefd4d98314c83b24eedbd6f180c.png";